import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import NotFound from "../../assets/not-found.png";
import { SERVER_URL } from "../../constant";
import { DatePicker } from "@mui/x-date-pickers";
import InputField from "../../component/InputField";
import AccrodianBox from "../../component/AccrodianBox";
import ButtonCompo from "../../component/ButtonCompo";
import DialogBox from "../../component/DialogBox";
import { TextField } from "@mui/material";
import dayjs from "dayjs";

function EmployeeGoalSettings() {
  const { userId } = useParams();
  const [taskData, setTaskData] = useState();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [reload, setReload] = useState(false);
  const [totalWeight, setTotalWeight] = useState(0);
  const [goalForm, setGoalForm] = useState(false);
  const [companyTask, setCompanyTask] = useState([]);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [weight, setWeight] = useState(0);
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()

  // fetch member details
  async function getUserGoal() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/goal/employee/get/${userId}`,
        method: "get",
        withCredentials: true,
      });
      //   console.log(res.data?.data);
      //   setTaskData(res.data?.data);
      //   let totalW = 0;
      //   res.data?.data?.map((weight) => {
      //     totalW += weight?.weight;
      //   });
      //   setTotalWeight(totalW);
    } catch (error) {
      console.log(error.status);
      if (error?.status === 404) {
        setGoalForm(true);
      } else {
        setOpen(true);
        setSuccess(false);
        setMessage("Task fetch failed");
      }
    } finally {
      setLoading(false);
    }
  }

  // fetch company task
  async function getCompanyTask() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/tasks/company`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setCompanyTask(res.data?.data);
      setTaskData(res.data?.data);
      let totalW = 0;
      res.data?.data?.map((weight) => {
        totalW += weight?.weight;
      });
      setTotalWeight(totalW);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Task fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // edit array task
  function editArrayTask(index) {
    const newObj = {
        title,
        description,
        startDate: startDate,
        endDate: endDate,
        weight
    }

    setTaskData(prev => {
        const arr = [...prev]
        arr[index] = newObj
        return arr
    })
  }

  // set value for edit
  function setValue(data) {
    setTitle(data?.title);
    setDescription(data?.description);
    setWeight(Number(data?.weight));
    setStartDate(data?.startDate)
    setEndDate(data?.endDate)
  }

  console.log(taskData);
  

  useEffect(() => {
    getUserGoal();
    getCompanyTask();
  }, []);

  if (goalForm) {
    return (
      <>
        <div className="w-full flex justify-center items-center">
          <div className="w-[90vw] lg:w-[50rem] py-5">
            <h1 className="text-[20px] sm:text-[30px] font-medium text-left w-full">
              Goal Settings
            </h1>
            <div className="w-full mt-5 space-y-3">
              <section>
                <label className="text-[15px] font-medium">Task Duration</label>
                <div className="grid grid-cols-2 gap-3 mt-3">
                  <DatePicker label="From" />
                  <DatePicker label="To" />
                </div>
              </section>
              <InputField label="Description" />
              <div className="mt-5 w-full">
                {taskData?.map((e, i) => (
                  <AccrodianBox title={<p>{e?.title} <span>{e?.startDate}</span></p>} headClass={"!font-medium"}>
                    <div className="w-full space-y-2">
                      <section>
                        <label className="text-[15px] font-medium">
                          Weight
                        </label>
                        <p className="text-slate-500">{e?.weight}%</p>
                      </section>
                      <section>
                        <label className="text-[15px] font-medium">
                          Description
                        </label>
                        <p className="text-slate-500">{e?.description}</p>
                      </section>
                      <section>
                        <div className="grid grid-cols-2 gap-3 mt-3">
                          <DatePicker label="From" value={e?.startDate} readOnly />
                          <DatePicker label="To" value={e?.endDate} readOnly />
                        </div>
                      </section>
                    </div>
                    <div className="w-full flex justify-end mt-5">
                      <DialogBox
                        trigger={
                          <ButtonCompo onClick={() => setValue(e)}>
                            edit
                          </ButtonCompo>
                        }
                        title="Add A Task"
                        actionButton={
                          <ButtonCompo onClick={() => editArrayTask(i)}>
                            Save
                          </ButtonCompo>
                        }
                        closeActionButton={<ButtonCompo>close</ButtonCompo>}
                      >
                        <div className="w-full space-y-3">
                          <InputField
                            label="Title"
                            onChange={(event) => setTitle(event?.target?.value)}
                            value={title}
                          />
                          <TextField
                            label="Description"
                            className="!w-full"
                            multiline
                            onChange={(event) =>
                              setDescription(event?.target?.value)
                            }
                            value={description}
                          />
                          <div className="grid grid-cols-2 gap-3 mt-3">
                            <DatePicker label="From" value={startDate} onChange={e => setStartDate(e)} />
                            <DatePicker label="To" value={endDate} onChange={e => setEndDate(e)} />
                          </div>
                          <InputField
                            label="Weight(in %)"
                            type="number"
                            onChange={(event) =>
                              setWeight(event?.target?.value)
                            }
                            value={weight}
                          />
                        </div>
                      </DialogBox>
                      <ButtonCompo
                        color={"error"}
                        onClick={() => deleteTask(e)}
                      >
                        delete
                      </ButtonCompo>
                    </div>
                  </AccrodianBox>
                ))}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return <div>Employee Goal Settings : {userId}</div>;
}

export default EmployeeGoalSettings;
